import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SET_ONBOARDING_HIGHLIGHTED_POSITION, SET_ONBOARDING_STEP, SET_FTUE_STEP, CLEAR_ONBOARDING, SET_FTUE_STATE, SET_FTUE_GAME } from '../actions/types';
var initialState = {
  ftueEnabled: false,
  ftueGameId: null,
  position: null,
  // { x: 50, y: 50, width: 100, height: 100 },
  tooltip: {
    message: null,
    customStyles: null,
    position: null
  },
  onboardingName: null,
  // 'favourites',
  currentStep: null,
  // 'favourites_1',
  ftueStep: null // **0-> set scroll **1-> highlight a game **2-> show in game highlight **3-> clicked on spinner **4-> finished and showing the popup
};
var currentOnboardingReducer = function currentOnboardingReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SET_ONBOARDING_HIGHLIGHTED_POSITION:
      return _objectSpread(_objectSpread({}, state), {}, {
        position: action.payload.position,
        tooltip: action.payload.tooltip
      });
    case SET_ONBOARDING_STEP:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentStep: action.payload
      });
    case SET_FTUE_GAME:
      return _objectSpread(_objectSpread({}, state), {}, {
        ftueGameId: action.payload
      });
    case SET_FTUE_STATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        ftueEnabled: action.payload
      });
    case SET_FTUE_STEP:
      return _objectSpread(_objectSpread({}, state), {}, {
        position: null,
        tooltip: {
          message: null,
          customStyles: null,
          position: null
        },
        ftueStep: action.payload
      });
    case CLEAR_ONBOARDING:
      return initialState;
    default:
      return state;
  }
};
export default currentOnboardingReducer;